import { render } from "./SectionMask.vue?vue&type=template&id=3772df28&scoped=true"
import script from "./SectionMask.vue?vue&type=script&lang=js"
export * from "./SectionMask.vue?vue&type=script&lang=js"

import "./SectionMask.vue?vue&type=style&index=0&id=3772df28&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3772df28"]])

export default __exports__